import React from 'react';
import { v4 as uuidv4 } from 'uuid';

// let result= "# 📊 키키컴퍼니 판매 전략 제안\n\n## 1. 최신 트렌드 분석 🌟\n\n최근 수정된 상품 리스트를 분석한 결과, 다음과 같은 카테고리와 트렌드가 주목됩니다:\n\n- **캐주얼 및 스포티 룩**: 편안하게 착용할 수 있는 트레이닝 세트, 크롭 맨투맨, 후드 스타일의 제품이 많습니다. 이러한 스타일은 데일리 룩으로 적합하며, MZ세대의 라이프스타일에 맞춰 인기 있는 트렌드입니다.\n- **빈티지와 와이드 실루엣**: 워싱 데님과 와이드 팬츠 등 빈티지한 감성을 가진 제품, 여기에 와이드 실루엣은 자유로운 스타일링을 선호하는 젊은 고객층에게 인기가 있습니다.\n- **겨울철 포근함**: 겨울 시즌에 맞춘 니트와 후드티 등 보온성이 강조된 제품이 트렌드로 자리잡고 있으며, 이는 계절적 특성을 반영하고 있습니다.\n\n## 2. 타겟층 분석 👥\n\n리스트 내 상품들은 주로 캐주얼하고 편안한 착용감, 스포티하면서 빈티지 스타일을 강조한 제품들로 구성되어 있습니다. 이러한 트렌드는 2030세대, 특히 패션을 통해 자기 표현을 즐기는 젊은 층을 주요 타겟으로 삼고 있다고 추측할 수 있습니다. 제품들에 다양한 핏과 스타일리시한 디자인이 포함된 점은 패션 감각이 뛰어난 대학생이나 직장 초년생을 겨냥했음을 시사합니다.\n\n## 3. 판매 전략 제안 💡\n\n### 트렌드 반영한 상품 배치 전략\n\n- **계절적 요소 반영**: 겨울철의 따뜻한 아이템, 예컨대 니트와 후드티, 후드집업을 가장 잘 보이는 위치에 배치하여 계절 트렌드를 강조합니다.\n- **스포티 캐주얼 스타일 강조**: 트레이닝 세트와 크롭 맨투맨 같은 스포티 아이템들을 메인 페이지 상단에 노출시켜 활동적인 라이프스타일을 강조합니다. 로보MD의 **자동 진열 및 위치 설정** 기능을 활용하여 스포티 관련 키워드와 연결된 상품을 상단에 배치합니다.\n\n### 연관 상품 진열 및 상위 노출 전략\n\n- **빈티지와 와이드 팬츠 컬렉션**: 와이드 팬츠와 관련된 다양한 상품을 함께 진열하여 스타일 다양성을 제공합니다. 로보MD의 **규칙 설정 및 복합 알고리즘**으로 와이드 팬츠와 매칭되는 상품군을 함께 노출합니다.\n- **코디 세트 제안**: 크롭 나그랑 후드집업과 와이드팬츠 등의 상품명을 활용한 코디 제안을 함께 노출하면 구매 전환율을 높일 수 있습니다. 로보MD의 **연관 상품 진열** 기능을 통해 이들을 패키지로 구성하여 고객이 한눈에 스타일을 파악할 수 있도록 지원합니다.\n\n### 클릭률 및 구매 전환율을 반영한 진열 최적화\n\n- **실시간 트렌드 적용**: 로보MD의 **AI 자동 진열**을 활용하여 조회수와 클릭률이 높은 상품을 실시간으로 반영하여 최적의 진열을 유지합니다.\n- **구매 데이터 분석**: 구매 전환율이 낮은 제품의 경우 가격 조정이나 프로모션 배너와 함께 노출하는 전략을 취할 수 있습니다. 로보MD의 **통계 확인** 기능으로 이런 데이터를 분석하여 맞춤형 전략을 세웁니다.\n\n### 맞춤형 판매 전략 제안\n\n- **컬러 테마 진열**: 컬러로 구분된 니트와 후드 제품을 별도의 테마 컬렉션으로 구성하여 시각적 매력을 높입니다. 로보MD의 **컬러 매칭 진열**을 기반으로 테마별로 진열 설정이 가능하도록 만듭니다.\n- **계절 행사 및 프로모션 전략**: 겨울철을 맞아 계절적 특성을 반영한 할인 이벤트를 기획하고, 프로모션 상품을 **알고리즘 상위 배분**을 통해 높게 노출합니다.\n\n이러한 전략들은 로보MD의 기능을 적절히 활용하여 실시간 트렌드와 시장 데이터를 통합, 고객의 선호도에 맞춘 효율적인 상품 전시에 기여할 것입니다. 📈"
class GptMarkdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: '',
            hasTypedSection: {},
        };
        this.introRef = React.createRef();
        this.sectionRef = React.createRef();
    }

    componentDidMount() {
        const { intro, section, step } = this.props;
      
        // 이미 타이핑한 섹션이면 아무것도 하지 않음
        if (this.state.hasTypedSection[step]) return;
      
        // step === 1이고 intro가 있을 때 → intro 먼저, 그 다음 section
        if (step === 1 && intro && this.introRef?.current && this.sectionRef?.current) {
            const introHtml = this.applyMarkdownStyle(intro);
            const sectionHtml = this.applyMarkdownStyle(section);
        
            this.renderHtmlWithTyping(introHtml, this.introRef.current, 15, () => {
                this.setState({ hasTypedIntro: true }, () => {
                    this.renderHtmlWithTyping(sectionHtml, this.sectionRef.current, 15, () => {
                        this.setState(prev => ({
                            hasTypedSection: { ...prev.hasTypedSection, [step]: true }
                        }));
                    });
                });
            });
        }
      
        // intro 없거나 step !== 1인 경우 바로 section만 타이핑
        else if (this.sectionRef?.current) {
            const sectionHtml = this.applyMarkdownStyle(section);
            this.renderHtmlWithTyping(sectionHtml, this.sectionRef.current, 15, () => {
                this.setState(prev => ({
                    hasTypedSection: { ...prev.hasTypedSection, [step]: true }
                }));
            });
        }
    }

    componentDidUpdate(prevProps) {
        const { intro, section, step } = this.props;
        
        // section 변경될 때만 처리
        if (prevProps.section !== section && this.sectionRef?.current) {
            // 이미 해당 섹션을 타이핑했다면 무시
            if (this.state.hasTypedSection[step]) return;
        
            // intro가 존재하고 step이 1이면 → intro 먼저, 그다음 section
            if (step === 1 && intro && this.introRef?.current) {
                const introHtml = this.applyMarkdownStyle(intro);
                const sectionHtml = this.applyMarkdownStyle(section);
            
                this.introRef.current.innerHTML = '';
                this.sectionRef.current.innerHTML = '';
            
                this.renderHtmlWithTyping(introHtml, this.introRef.current, 15, () => {
                    this.renderHtmlWithTyping(sectionHtml, this.sectionRef.current, 15, () => {
                        this.setState(prev => ({
                            hasTypedSection: { ...prev.hasTypedSection, [step]: true }
                        }));
                    });
                });
            }
        
            // intro가 없으면 바로 section 타이핑
            else {
                const sectionHtml = this.applyMarkdownStyle(section);
                this.sectionRef.current.innerHTML = '';
                this.renderHtmlWithTyping(sectionHtml, this.sectionRef.current, 15, () => {
                    this.setState(prev => ({
                        hasTypedSection: { ...prev.hasTypedSection, [step]: true }
                    }));
                });
            }
        }
    }
      

    applyMarkdownStyle(text) {
        // **Step 0: 두 번 개행 후 일반 텍스트 감지 및 <p> 태그로 감싸기**
        text = text.replace(
            /([.!?]\s*)(?:\r\n|\r|\n){2,}(?!(#|##|###|-|\*|>|[0-9]+\.)\s)([^\n<][^\n]*)/g,
            '$1\n<p class="summary-text">$3</p>'
        );

        // 1. 제목 변환 (`#` 기호 유지)
        text = text.replace(/^### (.+)$/gm, '<h3>$1</h3>');
        text = text.replace(/^## (.+)$/gm, '<h2>$1</h2>');
        text = text.replace(/^# (.+)$/gm, '<h1>$1</h1>');
    
        // 2. 수평선 변환 (`---`이 단독으로 있는 줄에만)
        text = text.replace(/^\s*---\s*$/gm, '<hr>');
    
        // 3. 목록 변환 (관련 내용 포함시키기)
        // - **강조 텍스트** 다음에 나오는 내용을 <li> 내부에 포함
        text = text.replace(/-\s+\*\*(.+?)\*\*\s*(.+?)(?=\n|$)/g, '<li><strong>$1</strong><p class="list-detail">$2</p></li>');
        text = text.replace(
            /-\s+(.*?)(?=\n|$)/g, 
            '<li>$1</li>'
        );
        text = text.replace(/(<li>[\s\S]+?<\/li>)/gm, '<ul>$1</ul>');
    
        // 4. 인용구 처리 (`>` 기호 사용)
        text = text.replace(/^\s*>\s+(.+)$/gm, '<blockquote>$1</blockquote>');
    
        // 5. 두 번 이상의 개행을 문단(`<p>`)으로 변환 (한 번 개행은 유지)
        text = text.replace(/\n{2,}/g, '</p><p>');
        
        // 6. 한 번 개행은 `<br>` 태그로 유지
        text = text.replace(/\n/g, '<br>');
        
        // 7. 첫 번째 문단 추가
        text = `<p>${text}</p>`;
        
        // 8. 빈 `<p>` 태그 제거
        text = text.replace(/<p>\s*<\/p>/g, '');
    
        // 9. <p> 태그 내부에 <br>만 있는 경우 <p> 태그 자체를 삭제
        text = text.replace(/<p[^>]*>(\s*<br>\s*)+<\/p>/g, '');
    
        // 10. **태그와 태그 사이의 `<br>` 제거** (텍스트 사이의 `<br>`은 유지)
        text = text.replace(/<\/([a-zA-Z0-9]+)>\s*<br>\s*<([a-zA-Z0-9]+)>/g, '</$1><$2>');
        
        // 11. **`</ul>` 다음에 오는 `<br>` 제거** 
        text = text.replace(/<\/ul>\s*<br>\s*(?=<h[1-6]>)/g, '</ul>');
    
        // 12. 굵은 글씨는 마지막에 변환 (다른 태그 내부에 적용되도록)
        text = text.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

        // 13. <h2>와 <br> 사이에 모든 공백 및 줄바꿈을 포함하여 제거
        text = text.replace(/(<h2[^>]*>[\s\S]*?<\/h2>)\s*<br\s*\/?>/g, '$1');

        // 14. <h3>와 <br> 사이에 모든 공백 및 줄바꿈을 포함하여 제거
        text = text.replace(/(<h3[^>]*>[\s\S]*?<\/h3>)\s*<br\s*\/?>/g, '$1');

        // 15. summary-text 앞의 <br> 제거**
        text = text.replace(/<br>\s*<p class="summary-text">/g, '<p class="summary-text">');

        return text;
    }

    renderHtmlWithTyping = (htmlString, container, delay = 35, callback) => {
        const step = this.props.step;
        if (this.state.hasTypedSection[step]) return;
      
        const parser = new DOMParser();
        const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
        const root = doc.body.firstChild;
      
        container.innerHTML = '';
        if (!root) return;
      
        const typeNode = (node, parent, onDone) => {
          if (node.nodeType === Node.TEXT_NODE) {
            const chars = Array.from(node.textContent);
            let i = 0;
      
            const typeChar = () => {
              if (i < chars.length) {
                parent.appendChild(document.createTextNode(chars[i++]));
                container.scrollTop = container.scrollHeight;
                setTimeout(typeChar, delay);
              } else {
                onDone && onDone();
              }
            };
            typeChar();
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            const el = node.cloneNode(false);
            parent.appendChild(el);
      
            const children = Array.from(node.childNodes);
            let idx = 0;
      
            const next = () => {
              if (idx < children.length) {
                typeNode(children[idx++], el, next);
              } else {
                onDone && onDone();
              }
            };
            next();
          } else {
            onDone && onDone();
          }
        };
      
        typeNode(root, container, () => {
          callback && callback();
        });
    };
      
    render() {
        const {className, maxWidth, width, height} = this.props;
        const {id} = this.state;
        return (
            <div className='flexBox' style={{flexDirection:'column', flexWrap:"nowrap", height:"100%"}}>
                <div
                    className={"gpt_mark_down " + (className ? className : "")}
                    style = {{
                        // maxWidth : maxWidth,
                        position: "relative",
                        width : width ? width : "100%",
                        height: height ? height : "auto"
                    }}

                    dangerouslySetInnerHTML={{__html:(`
                        <div class="flexBox title" style="flex-wrap:nowrap; align-items:center">
                            <img src="https://s3.ap-northeast-2.amazonaws.com/otdeal.file/0e962a7a54a126f4e37dde4810da9e4f7ad6f91e.png" style="width:100px"/>
                            <div style="flex:1; display: flex; align-items: center; margin-left: 10px">${this.applyMarkdownStyle(this.props.title)}</div>
                        </div> 
                        `
                    )}}
                >
                </div>
                {
                    this.props.intro && this.props.step == 1 &&
                    <div
                        className={"gpt_mark_down intro " + (className ? className : "")}
                        style={{
                        position: "relative",
                        width: width ? width : "100%",
                        height: "auto",
                        }}
                        ref={this.introRef}
                    />
                }
                <div
                    className={"gpt_mark_down " + (className ? className : "")}
                    style={{
                        position: "relative",
                        width: width ? width : "100%",
                        flex: 1,
                        overflow: "auto"
                    }}
                    ref={this.sectionRef}
                />
            </div>
        );
    }
}

export default GptMarkdown;